import React from 'react';
import Bannerimage from '../../assets/images/hero_image.webp';
import Bannerimg01 from '../../assets/images/black_google_play.webp';
import Bannerimg02 from '../../assets/images/black_appstore.webp';
import PlayStoreLink from '../Global/PlayStoreLink';
import AppStoreLink from '../Global/AppStoreLink';
import { siteCopy } from '../../content/siteCopy';

const Banner = () => {
  return (
      <>
        <section className="banner_section white_text" id="home_sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12" data-aos="fade-up" data-aos-duration={1500}>
                <div className="banner_text">
                  <h1>{siteCopy.banner.headline}</h1>
                  <p>{siteCopy.banner.body}</p>
                  {siteCopy.banner.trustStrip ? (
                    <p className="banner_trust_strip">{siteCopy.banner.trustStrip}</p>
                  ) : null}
                </div>
                <ul className="app_btn">
                  <li>
                    <PlayStoreLink>
                      <img className="blue_img" src={Bannerimg01} alt="Get it on Google Play" />
                    </PlayStoreLink>
                  </li>
                  <li>
                    <AppStoreLink>
                      <img className="blue_img" src={Bannerimg02} alt="Download on the App Store" />
                    </AppStoreLink>
                  </li>
                </ul>
              </div>
              <div className="col-md-12">
                <div className="hero_img">
                  <div className="desktop">
                    <img src={Bannerimage} alt="Noor app: explore modules and daily wellbeing tools" />
                  </div>
                  <div className="mobile_view">
                    <img src={Bannerimage} alt="Noor app: explore modules and daily wellbeing tools" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
  )
}

export default Banner
